import { Component, Input, forwardRef } from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component({
  selector: 'dp-datepicker',
  standalone: true,
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: './dp-datepicker.component.html',
  styleUrls: ['./dp-datepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DpDatepickerComponent),
      multi: true,
    },
    provideNativeDateAdapter(),
  ],
})
export class DpDatepickerComponent implements ControlValueAccessor {
  @Input() public placeholderLevel: string = '';
  @Input() public datePickerClass: string = '';
  @Input() public mask: string = '00/00/0000';
  maxDate = new Date().toISOString().split('T')[0];
  dateControl = new FormControl();
  onChange = (date: any) => {};
  onTouched = () => {};

  writeValue(date: any): void {
    this.dateControl.setValue(date);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.dateControl.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.dateControl.disable() : this.dateControl.enable();
  }
}
